module.exports = __webpack_public_path__ + "static/img/12.38823d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/12.jpg
// module id = cawM
// module chunks = 1